import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { AumicoCoreProvider } from '../../../../aumico-lib-core-fe/src/lib';
import { UsersConfig, UsersConfigService } from '../../../../aumico-lib-users-fe/src/lib/users.config';
import { RoutesUtil } from '../../../../aumico-lib-users-fe/src/lib/util/RoutesUtil';
import { UpdateWorkflowSectionDto } from '../dtos/update-workflow-section-dto.interface';
import { WorkflowSectionDto } from '../dtos/workflow-section-dto.interface';

@Injectable({
    providedIn: 'root',
})
export class WorkflowSectionsService {
    constructor(
        private http: HttpClient,
        @Inject(UsersConfigService) config: UsersConfig,
        private readonly coreProvider: AumicoCoreProvider,
        private routesUtil: RoutesUtil,
    ) {}

    getWorkflowSections(): Observable<WorkflowSectionDto[]> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Get Workflow Sections');

        const url = this.routesUtil.getWorkflowSections();

        return this.http
            .get<WorkflowSectionDto[]>(url)
            .pipe(
                finalize(() =>
                    this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Get Workflow Sections'),
                ),
            );
    }

    updateWorkflowSection(
        sectionId: string,
        updateWorkflowSectionDto: UpdateWorkflowSectionDto,
    ): Observable<WorkflowSectionDto> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflow-Sections] Update Workflow Section');

        const url = this.routesUtil.getWorkflowSectionById(sectionId);

        return this.http
            .put<WorkflowSectionDto>(url, updateWorkflowSectionDto)
            .pipe(
                finalize(() =>
                    this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflow-Sections] Update Workflow Section'),
                ),
            );
    }

    deleteWorkflow(workflowId: string): Observable<void> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Delete Workflow By Id');

        const url = this.routesUtil.getWorkflowSectionById(workflowId);

        return this.http
            .delete<void>(url)
            .pipe(
                finalize(() =>
                    this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Delete Workflow By Id'),
                ),
            );
    }
}
